// DR-1845 code-inspection fix (Major) - showAddressRequiredAlert() and
// confirmProceedWithoutAddress() were duplicated verbatim between
// new-beneficiary-details.vue (Create) and beneficiary-modify.vue (Modify),
// unlike the isAddressSectionInScope scope-check formula (beneficiary.store.js),
// which this same ticket correctly centralized into a single shared Vuex
// getter. Extracted here so both views share one copy - the dialog
// wording/styling was already iterated 3 times during this ticket alone, and
// leaving it duplicated risks the exact "isAddressSectionInScope drift" bug
// this ticket had to fix elsewhere via a revert (9a04946b/d04e429a).
//
// Local mixin (not a Vue.mixin() global plugin like plugins/mixin.js) -
// import and add to a component's `mixins: [...]` array. Requires the
// consuming component to provide: isAddressSectionInScope, addressHardMandatory,
// beneficiaryCountryId, beneficiaryTownCity (as data/computed/mapGetters), and
// the standard $f7/$t/$$ globals - both new-beneficiary-details.vue and
// beneficiary-modify.vue already do.
export default {
    methods: {
        // DR-1845 - shown when the global BENEFICIARY_ADDRESS_MANDATORY toggle
        // is Y (addressHardMandatory true) for a destination that requires the
        // address and the customer left Country/Town-City blank - the field-level
        // validation already blocked submission (inline error under each
        // field), this just surfaces it as a popup too, same styling as the
        // soft-mandatory confirm but single-button (no "proceed anyway" - it's
        // mandatory, there is nothing to bypass).
        showAddressRequiredAlert() {
            const self   = this;
            // DR-1845 code-inspection fix (Major, §4.3 Browser-Side Security) -
            // Framework7's dialog `text` option is injected as raw HTML, NOT
            // Vue-escaped (confirmed via F7 source: `${text}` goes straight into
            // .dialog-text innerHTML) - that's why the i18n string below uses
            // <br><br> instead of \n\n for line breaks. It is a static i18n
            // string today with no XSS impact, but NEVER build this `text` value
            // via concatenation/interpolation of a beneficiary/customer-supplied
            // value (e.g. a city or name) - that would reopen a real HTML-injection
            // vector. If dynamic content is ever needed here, sanitize it first or
            // switch to a plain-text dialog + CSS `white-space: pre-line`.
            const dialog = self.$f7.dialog.create({
                title   : self.$t('beneficiary-address-hard-required-title'),
                text    : self.$t('beneficiary-address-hard-required'),
                cssClass: 'dialog-buttons-2 single-button',
                buttons : [
                    {text: self.$t('general-text-got-it'), cssClass: 'confirm-yes', onClick: () => dialog.close()},
                ],
                on      : {
                    open: function () {
                        self.$$('.dialog.dialog-buttons-2').prepend("<span class='close-button'><span>");
                    },
                    opened: function() {
                        self.$$('.dialog.dialog-buttons-2 .close-button').on('click', function () {
                            dialog.close();
                        });
                    },
                    closed: function () {
                        self.$$('.dialog.dialog-buttons-2 .close-button').remove();
                        dialog.destroy();
                    }
                }
            });
            dialog.open();
        },

        // DR-1845 - soft-mandatory confirm: only fires when this destination
        // wants Beneficiary Country/Town-City (isAddressSectionInScope) AND the
        // global toggle is off (addressHardMandatory false, so the field-level
        // validation never blocked) AND the value is actually still blank.
        // Resolves true to proceed, false to stay on the form - mirrors retail's
        // CreateRemittance.jsp doSubmit() window.confirm() gate 1:1. Styled with
        // the app's standard 2-button confirm dialog (dialog-buttons-2) instead
        // of the plain default $f7.dialog.confirm().
        confirmProceedWithoutAddress() {
            const addressBlank = !this.beneficiaryCountryId || this.beneficiaryCountryId <= 0
                || !this.beneficiaryTownCity || this.beneficiaryTownCity.trim().length === 0;

            if(!this.isAddressSectionInScope || this.addressHardMandatory || !addressBlank) {
                return Promise.resolve(true);
            }

            const self = this;
            return new Promise((resolve) => {
                // DR-1845 code-inspection fix (Major, §4.3) - same raw-HTML `text`
                // caveat as showAddressRequiredAlert() above - see that comment.
                const dialog = self.$f7.dialog.create({
                    title   : self.$t('beneficiary-address-soft-confirm-title'),
                    text    : self.$t('beneficiary-address-soft-confirm'),
                    cssClass: 'dialog-buttons-2',
                    buttons : [
                        {text: self.$t('general-text-btn-cancel'), cssClass: 'confirm-no', onClick: () => resolve(false)},
                        {text: self.$t('general-text-continue'), cssClass: 'confirm-yes', onClick: () => resolve(true)},
                    ],
                    on      : {
                        open: function () {
                            self.$$('.dialog.dialog-buttons-2').prepend("<span class='close-button'><span>");
                        },
                        opened: function() {
                            self.$$('.dialog.dialog-buttons-2 .close-button').on('click', function () {
                                resolve(false);
                                dialog.close();
                            });
                        },
                        closed: function () {
                            self.$$('.dialog.dialog-buttons-2 .close-button').remove();
                            dialog.destroy();
                        }
                    }
                });
                dialog.open();
            });
        },
    }
}
